import React, { useMemo } from "react";
import { Title, Subtitle, PageWrapper } from "../../settings/layout";
import { HomeHeader, HomeList } from "./styles";
import Button from "../../components/Button";
import ListExpenses from "../../components/ListExpenses";
import Breadcrumb from "../../components/Breadcrumb";
import PageHeader from "../../components/PageHeader";
import Icons from "../../components/Icons";
import { connect } from "react-redux";
import IReduxStore from "../../interfaces/IReduxStore";
import { IExpenseStore } from "../../store/ducks/expenses";

interface IProps {
    expenses: IExpenseStore;
}

const Home = ({ expenses }: IProps) => {
    const sumExpenses = useMemo(() => {
        try {
            const sum = expenses.items.reduce(
                (acc, curr: any) => Number(acc) + Number(curr.amount),
                0
            );

            return sum;
        } catch (error) {
            return 0;
        }
    }, [expenses]);

    console.log("sumExpenses", sumExpenses);

    return (
        <PageWrapper>
            <HomeHeader>
                <PageHeader style={{ flex: 1 }}>
                    <Breadcrumb
                        links={[{ name: "Home", path: "/app", active: true }]}
                    />

                    <Title>Gastos</Title>
                    {/* <Subtitle>01-31 Abril, 2020</Subtitle> */}
                    <Subtitle>R${sumExpenses?.toFixed(2)}</Subtitle>
                </PageHeader>

                <Button rounded linked to="/app/gasto/adicionar" variant="Info">
                    <Icons name="add" width={20} height={20} />
                </Button>
            </HomeHeader>

            <HomeList>
                <ListExpenses title="Hoje" items={expenses.items} />
            </HomeList>
        </PageWrapper>
    );
};

const mapStateToProps = ({ expenses }: IReduxStore) => ({
    expenses,
});

export default connect(mapStateToProps)(Home);
